module.exports = __webpack_public_path__ + "static/assets/4315d75f8ed05856ec4150b800b683ad.png";